import type { IVueI18n } from 'vue-i18n';

export function formatNumberAsCurrency(
  value: number | null | undefined,
  opts: { i18n: IVueI18n; currencyCode: string },
): string {

  if (value === null || value === undefined) {

    return '';

  }

  const { i18n, currencyCode } = opts;

  return i18n.n(value, {
    style: 'currency',
    currency: currencyCode,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });

}
